import { API } from "src/constants/api";
import HttpService from "./HttpService";

const httpService = HttpService.instance;

export const getPractionerIdByAuthId = async (authId: string) => {
  const request_url = `${API.PRACTITIONER}?identifier=${authId}`;
  const response = await httpService.callCdr(request_url, "GET");
  return response?.data;
};
